// Which MODULES this account has activated (redesign stage 1, 23 Oct 2026). One read of GET /options-access/me -
// the same answer the server uses to allow or refuse - shared by the sidebar (lock icons) and the route gate.
// Presentation only: every API still enforces access itself. A missing LIVE flag never deactivates a module
// (simulated access is enough); market hours, broker connection and funds are page states, never gates.
import { useEffect, useState } from "react";
import api from "@/lib/api";

export const MODULE = { FUTURES: "futures", OPTIONS: "options", ANALYSIS: "analysis", HEDGE: "hedge", IRON_CONDOR: "iron_condor" };

let cache = null;
let inflight = null;
const listeners = new Set();

/** {loaded, futures, options, analysis, hedge, iron_condor} from the server's answer. */
export function modulesFrom(me) {
  const prod = me?.products || { futures: true, options: false };
  return {
    loaded: true,
    futures: !!prod.futures,
    options: !!prod.options,
    analysis: !!me?.analysis?.allowed,
    hedge: !!me?.hedge?.allowed,
    iron_condor: !!me?.iron_condor?.allowed,
  };
}

export function loadModules(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/options-access/me").then((r) => modulesFrom(r.data))
      // unreachable server: futures only, like useProducts (never a false "activated")
      .catch(() => modulesFrom(null))
      .then((m) => { cache = m; inflight = null; listeners.forEach((fn) => fn(m)); return m; });
  }
  return inflight;
}

export function resetModules() { cache = null; inflight = null; }

export function useModules() {
  const [m, setM] = useState(cache);
  useEffect(() => {
    listeners.add(setM);
    loadModules().then(setM);
    const t = setInterval(() => { if (!document.hidden) loadModules(true); }, 60000);
    return () => { listeners.delete(setM); clearInterval(t); };
  }, []);
  return m || { loaded: false };
}

/** Is `module` activated? Unknown / still loading counts as activated (the page then decides; no lock flash). */
export function isActive(mods, module) {
  if (!module || !mods?.loaded) return true;
  return !!mods[module];
}
